import { render } from "./CosmoCustomizeNewApp.vue?vue&type=template&id=c0dd5d9e&scoped=true"
import script from "./CosmoCustomizeNewApp.vue?vue&type=script&lang=js"
export * from "./CosmoCustomizeNewApp.vue?vue&type=script&lang=js"

import "./CosmoCustomizeNewApp.vue?vue&type=style&index=0&id=c0dd5d9e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0dd5d9e"]])

export default __exports__